export default __webpack_public_path__ + "static/media/file.29cb8821.jpg";